import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportRegistrationWithCodeComponent } from './component/transport-registration-with-code.component';
import { MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { DictionaryModule } from '@sdbn/appclient';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonTranslationModule, CommonLayoutModule } from '@sdbn/common';



@NgModule({
  declarations: [
    TransportRegistrationWithCodeComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    DictionaryModule,
    FormsModule,
    ReactiveFormsModule,
    CommonTranslationModule,
    ServiceResponseModule,
    CommonLayoutModule
  ]
})
export class TransportRegistrationWithCodeModule { }
